import { graphql, useStaticQuery } from "gatsby"

import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import React from "react"

const SEO = ({ description, image, meta, keywords, title, article, template, noIndex }) => {
  const { site } = useStaticQuery(query)

  const metaDescription = description || site.siteMetadata.description
  // const image =
  //   metaImage && metaImage.src
  //     ? `${site.siteMetadata.siteUrl}${metaImage.src}`
  //     : null

  let metaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:title`,
      content: `${ title }${ !template ? ' | Interact' : ''}`,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: article ? `article` : `website`,
    },
    {
      property: "og:image",
      content: image ? image.src : `${ site.siteMetadata.siteUrl }${ site.siteMetadata.image.src }`,
    },
    {
      property: "og:image:width",
      content: image ? image.width : site.siteMetadata.image.width,
    },
    {
      property: "og:image:height",
      content: image ? image.height : site.siteMetadata.image.height,
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:image",
      content: image ? image.src : `${ site.siteMetadata.siteUrl }${ site.siteMetadata.image.src }`,
    },
    {
      name: `twitter:site`,
      content: `@${ site.siteMetadata.social.twitter }`,
    },
    {
      name: `twitter:title`,
      content: `${ !template ? 'Interact | ' : ''}${ title }`,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ]

  if (noIndex) {
    metaTags = [
      {
        name: `robots`,
        content: `noindex, nofollow`
      },
      ...metaTags
    ]
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: site.siteMetadata.lang,
      }}
      title={title || site.siteMetadata.title}
      titleTemplate={template ? `%s` : `%s | ${site.siteMetadata.title}`}
      meta={ metaTags }
    />
  )
}

export default SEO

SEO.defaultProps = {
  lang: `en`,
  meta: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        title
        siteUrl
        description
        image {
          src
          width
          height
        }
        author
        social {
          twitter
        }
      }
    }
  }
`